module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aleg51-e9db071182b4a1f51246f1b6a149f39e.jpg";